import { c as _c } from "react/compiler-runtime";
import { Box, Flex, Stack } from '@repo/pandacss/jsx';
import { AnalyticsFeatureViewed } from '@repo/platform-analytics/AnalyticsFeatureViewed';
import { useAnalyticsSkuViewedContext } from '@repo/platform-analytics/AnalyticsSkuViewed/Context';
import { ElementViewed } from '@repo/platform-analytics/ElementViewed';
import { InfoTooltip } from '@repo/ui/composites/InfoTooltip';
import { Typography, type TypographyPropsBag } from '@repo/ui/Typography';
import { getApprovalLikelihoodLabel, getOddsLabel } from '../../lib/approvalOdds';
import type { Odds } from '../../model/approval-odds/types';
import { ApprovalOddsButton } from './ApprovalOddsButton';
export const ApprovalOddsLikelihoodContent = t0 => {
  const $ = _c(61);
  const {
    userCreditScore,
    odds,
    isAmexOffer,
    approvalLikelihood,
    typographyProps
  } = t0;
  const {
    skuImpressionId
  } = useAnalyticsSkuViewedContext();
  const {
    min,
    max
  } = odds;
  if (!userCreditScore || approvalLikelihood == null) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = {
        position: "relative"
      };
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        flexDirection: {
          base: "column",
          _pcMd: "row"
        }
      };
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== isAmexOffer || $[3] !== max || $[4] !== min) {
      t3 = !isAmexOffer && <Typography>{min}-{max}</Typography>;
      $[2] = isAmexOffer;
      $[3] = max;
      $[4] = min;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = {
        ml: {
          base: "0",
          _pcMd: "1"
        }
      };
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[7] !== isAmexOffer || $[8] !== max || $[9] !== min) {
      t5 = !isAmexOffer ? `(${getOddsLabel(min, max)})` : getOddsLabel(min, max);
      $[7] = isAmexOffer;
      $[8] = max;
      $[9] = min;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    let t6;
    if ($[11] !== t5) {
      t6 = <Typography css={t4}>{t5}</Typography>;
      $[11] = t5;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    let t7;
    if ($[13] !== t3 || $[14] !== t6) {
      t7 = <Flex css={t2}>{t3}{t6}</Flex>;
      $[13] = t3;
      $[14] = t6;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    let t8;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <ApprovalOddsButton />;
      $[16] = t8;
    } else {
      t8 = $[16];
    }
    let t9;
    if ($[17] !== t7) {
      t9 = <Box css={t1}>{t7}{t8}</Box>;
      $[17] = t7;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    return t9;
  }
  let T0;
  let T1;
  let label;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[19] !== approvalLikelihood || $[20] !== skuImpressionId) {
    label = getApprovalLikelihoodLabel(approvalLikelihood);
    T1 = AnalyticsFeatureViewed;
    t5 = "cc_approval_odds";
    t6 = "";
    t7 = skuImpressionId;
    t8 = 0;
    t9 = {
      approval_odds: label.toLowerCase()
    };
    T0 = ElementViewed;
    t2 = "cc_approval_odds_likelihood";
    t3 = "offer_product_card";
    t4 = 0;
    t1 = label.toLowerCase();
    $[19] = approvalLikelihood;
    $[20] = skuImpressionId;
    $[21] = T0;
    $[22] = T1;
    $[23] = label;
    $[24] = t1;
    $[25] = t2;
    $[26] = t3;
    $[27] = t4;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
    $[31] = t8;
    $[32] = t9;
  } else {
    T0 = $[21];
    T1 = $[22];
    label = $[23];
    t1 = $[24];
    t2 = $[25];
    t3 = $[26];
    t4 = $[27];
    t5 = $[28];
    t6 = $[29];
    t7 = $[30];
    t8 = $[31];
    t9 = $[32];
  }
  let t10;
  if ($[33] !== skuImpressionId || $[34] !== t1) {
    t10 = {
      approval_odds: t1,
      sku_impression_id: skuImpressionId
    };
    $[33] = skuImpressionId;
    $[34] = t1;
    $[35] = t10;
  } else {
    t10 = $[35];
  }
  const t11 = typographyProps?.css;
  let t12;
  if ($[36] !== t11) {
    t12 = {
      display: "inline",
      textTransform: "capitalize",
      ...t11
    };
    $[36] = t11;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  let t13;
  if ($[38] !== label || $[39] !== t12) {
    t13 = <Typography css={t12}>{label}</Typography>;
    $[38] = label;
    $[39] = t12;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  let t14;
  if ($[41] !== label) {
    t14 = <InfoTooltip ariaLabel="More information about your approval likelihood" text={<p>We think your odds of getting approved for this card are<strong> {label} </strong>based on your credit score and other factors. That said, these odds are an estimate to help you narrow your choices, not a guarantee. Card issuers may use different criteria than we do.</p>} />;
    $[41] = label;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  let t15;
  if ($[43] !== t13 || $[44] !== t14) {
    t15 = <Stack direction="row" gap="1">{t13}{t14}</Stack>;
    $[43] = t13;
    $[44] = t14;
    $[45] = t15;
  } else {
    t15 = $[45];
  }
  let t16;
  if ($[46] !== T0 || $[47] !== t10 || $[48] !== t15 || $[49] !== t2 || $[50] !== t3 || $[51] !== t4) {
    t16 = <T0 entityName={t2} sectionName={t3} itemPosition={t4} additionalAttributes={t10}>{t15}</T0>;
    $[46] = T0;
    $[47] = t10;
    $[48] = t15;
    $[49] = t2;
    $[50] = t3;
    $[51] = t4;
    $[52] = t16;
  } else {
    t16 = $[52];
  }
  let t17;
  if ($[53] !== T1 || $[54] !== t16 || $[55] !== t5 || $[56] !== t6 || $[57] !== t7 || $[58] !== t8 || $[59] !== t9) {
    t17 = <T1 entityName={t5} entitySection={t6} parentActivityId={t7} impressionPosition={t8} additionalAttributes={t9}>{t16}</T1>;
    $[53] = T1;
    $[54] = t16;
    $[55] = t5;
    $[56] = t6;
    $[57] = t7;
    $[58] = t8;
    $[59] = t9;
    $[60] = t17;
  } else {
    t17 = $[60];
  }
  return t17;
};